export const EditSlugs = {
    campaigns: 'campaigns',
} as const;

export function getEditDealerCampaignsUrl(dealerSlug: string): string {
    return `/${dealerSlug}/edit/${EditSlugs.campaigns}`;
}

export function getEditDealerCampaignUrl(dealerSlug: string, campaignId: number): string {
    return `${getEditDealerCampaignsUrl(dealerSlug)}/${campaignId}`;
}

export function getNewDealerCampaignUrl(dealerSlug: string): string {
    return `${getEditDealerCampaignsUrl(dealerSlug)}/new`;
}

export function getCopyDealerCampaignUrl(dealerSlug: string, campaignId: number): string {
    return `${getEditDealerCampaignsUrl(dealerSlug)}/copy/${campaignId}`;
}
